const regionSettings = require('@/' + process.env.VUE_APP_REGION + '.yml')
import { ORDER_TYPES } from 'nandos-middleware-api/model/food-basket'
import FoodBasketItem from 'nandos-middleware-api/model/food-basket-item'
import GiftCardBasketItem from 'nandos-middleware-api/model/gift-card-basket-item'
import UserProduct from 'nandos-middleware-api/model/user-product'
import Tracker from '../e-commerce-tracker'

let AppsFlyer;

export default class AppsflyerAnalyticsTracker {

  constructor() {
    AppsFlyer = window.plugins.appsFlyer
    if(!AppsFlyer) {
      throw new Error('AppsflyerAnalyticsTracker:: AppsFlyer plugin not available')
    }

    let options = {
      devKey:  process.env.VUE_APP_APPS_FLYER_API_KEY,
      onInstallConversionDataListener: true,
    }
    
    console.warn('TODO:: add @capacitor/device plugin')
    if (device.platform == 'iOS') options.appId = process.env.VUE_APP_IOS_APP_STORE_ID;

    AppsFlyer.setCurrencyCode(regionSettings.currency);
    AppsFlyer.initSdk(options, attribution => Tracker.track('setAttributionData', attribution));
  }

  setUser(user) {
    let id = user.anonymous == true ? null : user.id
    AppsFlyer.setAppUserId(id)
  }

  productView(product) {
    let data = getTrackingDataFromItem(product)
    AppsFlyer.logEvent('af_content_view', data)
  }

  addToCart(products) { /* Products or GiftCards */
    Array.isArray(products)
      ? products.forEach(product => AppsFlyer.logEvent('af_add_to_cart', getTrackingDataFromItem(product)))
      : AppsFlyer.logEvent('af_add_to_cart', getTrackingDataFromItem(products))
  }

  removeFromCart(basketItem) {
    AppsFlyer.logEvent('remove_from_cart', getTrackingDataFromItem(basketItem))
  }

  checkout(step, basket) {
    if(step == 1) {
      AppsFlyer.logEvent('af_initiated_checkout', {
        af_price: _toMoney(basket.totalPrice),
        af_content_id: basket.items.map(getTrackingDataFromItem).map(i => i.af_content_id),
        af_content_type: basket.items.map(getTrackingDataFromItem).map(i => i.af_content_type),
        af_quantity: basket.items.map(getTrackingDataFromItem).map(i => i.af_quantity),
      })
    }
  }

  paymentOption(paymentSource, paymentAmount, isMultiPartPayment) {
    AppsFlyer.logEvent('payment_option', {
      paymentOption: paymentSource,
      optionRevenue: _toMoney(paymentAmount),
      paymentType: isMultiPartPayment ? 'PARTIAL' : 'FULL',
    })
  }

  purchase(transactionId, basket, affiliation) {
    AppsFlyer.logEvent('af_purchase', {
      af_order_id: transactionId,
      af_receipt_id: transactionId,
      af_revenue: _toMoney(basket.totalPrice),
      af_content_id: basket.items.map(getTrackingDataFromItem).map(i => i.af_content_id),
      af_content_type: basket.items.map(getTrackingDataFromItem).map(i => i.af_content_type),
      af_quantity: basket.items.map(getTrackingDataFromItem).map(i => i.af_quantity),
      shipping: basket.deliveryPrice ? _toMoney(basket.deliveryPrice) : undefined,
      tax: _toMoney(basket.totalVat),
      affiliation: affiliation,
      order_type: _getOrderTypeFromBasket(basket),
    })
  }

  search(path, queryParams) {
    AppsFlyer.logEvent('af_search', {
      af_search_string: queryParams['query'],
      search_ctx: queryParams['search-ctx'],
    })
  }

  signUp(method) {
    AppsFlyer.logEvent('af_complete_registration', {
      af_registration_method: method,
    })
  }

  login(method) {
    AppsFlyer.logEvent('af_login', {
      method: method,
    })
  }
}

function _getOrderTypeFromBasket(basket) {
  switch(basket.orderType) {
    case ORDER_TYPES.DELIVERY: return 'delivery'
    case ORDER_TYPES.COLLECTION: return basket.kerbsideCollect ? 'kerbside' : 'collection'
    case ORDER_TYPES.EAT_IN: return 'eatIn'
  }
}

function _toMoney(val) {
  return parseFloat(val / 100)
}

function getTrackingDataFromItem(item) {
  if(item instanceof UserProduct) {
    return _getTrackingDataFromProduct(item)
  }
  else if(item instanceof FoodBasketItem) {
    return _getTrackingDataFromFoodBasketItem(item)
  }
  else if(item instanceof GiftCardBasketItem) {
    return _getTrackingDataFromGiftCard(item)
  }
  else {
    return item
  }
}

function _getTrackingDataFromProduct(product) {
  return {
    af_content_id: product.getId(),
    af_content: product.getName(),
    variant: product.getConfigurationDescription(),
    af_content_type: product.trackingCategory || 'Food',
    af_price: _toMoney(product.computePrice()),
    af_quantity: product.orderQuantity,
  }
}

function _getTrackingDataFromFoodBasketItem(item) {
  return {
    af_content_id: item.id,
    af_content: item.productName,
    variant: item.computedDescription,
    af_content_type: item.trackingCategory || 'Food',
    af_price: _toMoney(item.productPrice),
    af_quantity: item.quantity,
  }
}

function _getTrackingDataFromGiftCard(item) {
  return {
    af_content_id: `nandos-gift-card`,
    af_content: 'Gift Card',
    variant: `${_toMoney(item.price)}, design: ${item.srcImageUrl}`,
    af_content_type: 'Gift Cards',
    af_price: _toMoney(item.price),
    af_quantity: item.cards.length,
  }
}